<template>
  <div>
    <FaqSection />
  </div>
</template>

<script>
import FaqSection from '@/components/home/FaqSection.vue'

export default {
  name: 'FaqView',
  components: {
    FaqSection
  }
}
</script>
